import { NameResourceItem } from "../NameResourceItem";
import { createFullClassResource } from "../../fullResource";

export class JednostkaSprzedazy extends NameResourceItem {}

export const jednostkaSprzedazyResource = createFullClassResource(
  "plm/jednostkaSprzedazy/",
  JednostkaSprzedazy,
);
